<template>
    <div>
        <viewer v-if="isKonfirmasi" :value="form" :barangs="barangs" is-konfirmasi @koreksi="koreksi" @ok="save"></viewer>
        <b-card v-show="!isKonfirmasi" v-if="form" class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isEdit ? 'Edit' : 'Buat' }} Blending</h5>
            </b-card-header>
            <b-card-body>
                <div class="row">
                    <div class="col-md">
                        <label class="form-control-label">Detail Barang</label>
                        <div class="table-responsive">
                            <table class="table">
                                <tr>
                                    <th>Kode</th>
                                    <th>Berat</th>
                                    <th>Grade</th>
                                    <th class="text-center">Aksi</th>
                                </tr>
                                <tr v-for="(item, index) in barangs">
                                    <td class="text-nowrap pl-0 fit-column">
                                        <div class="input-group mb-0 d-flex" style="width: 20rem;">
                                            <multiselect style="width:10rem; max-width: 10rem;" :class="'w-auto flex-grow-1'" v-model="barangs[index]" :options="[barangs[index]]" :placeholder="'Pilih barang'" :searchable="true"
                                                label="code" track-by="id" :allowEmpty="false" :show-labels="false"></multiselect>
                                            <div class="input-group-append">
                                                <button class="btn btn-primary mr-1" type="button" @click="findBarang(index)"><i class="fas fa-search"></i> Pilih</button>
                                                <button class="btn btn-primary" type="button" @click="findScan(index)"><i class="fas fa-qrcode"></i> Scan</button>
                                            </div>
                                        </div>
                                        <input v-show="false" v-validate="'required'" v-model="item.id" type="text" :name="'barang-'+index" class="form-control">
                                        <span class="text-danger">{{ errors.first('barang-'+index) }}</span>
                                    </td>
                                    <td class="text-nowrap pl-0 fit-column">
                                        <div v-if="item.id" class="input-group mb-0 d-flex" style="width: 10rem;">
                                            <input style="width:7rem; max-width: 7rem;" v-validate="'required'" v-model="barangs[index].latest_bobot" type="number" :name="'bobot'+index" class="form-control">
                                            <div class="input-group-append">
                                                <span class="input-group-text">KG</span>
                                            </div>
                                        </div>
                                        <div v-else>-</div>
                                        <span class="text-danger">{{ errors.first('bobot'+index) }}</span>
                                    </td>
                                    <td class="text-nowrap">
                                        {{ item.latest_grade ? item.latest_grade.name : '-' }}
                                    </td>
                                    <td class="text-center">
                                        <button v-if="barangs.length > 1" type="button" title="Delete" @click="deleteBarang(index)" class="btn btn-link text-danger px-1"><i class="fas fa-times-circle"></i></button>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pl-0" colspan="4">
                                        <button class="btn btn-sm btn-primary" type="button" @click="addBarang"><i class="fas fa-plus"></i> Barang</button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="row mt-3">
                    <div class="col-md">
                        <div class="form-group">
                            <label class="form-control-label">Gudang</label>
                            <multiselect class="w-auto flex-grow-1 disabled-multiselect" name="gudang" v-model="form.gudang" :options="gudangOptions"
                                label="name" track-by="id" :allowEmpty="false" placeholder="" :show-labels="false"></multiselect>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md">
                        <div class="form-group">
                            <label class="form-control-label">Tanggal Blending</label>
                            <div class="input-group mb-0 d-flex">
                                <date-picker class="w-auto flex-grow-1" v-model="form.tanggal_blending" v-validate="'required'" type="date" name="tanggal_blending" placeholder="Tanggal Blending" :editable="true" format="DD-MM-YYYY"></date-picker>
                            </div>
                            <span class="text-danger">{{ errors.first('tanggal_blending') }}</span>
                        </div>
                    </div>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                <button :disabled="isLoading" @click="kirim(isEdit)" type="button" class="btn btn-primary mr-2">{{ isEdit ? 'Simpan' : 'Blending' }}</button>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectBarang" size="lg" :hide-header="true" :hide-footer="true">
            <barang-selector one-data :selected="barangs" :latest-gudang-id="form.gudang ? form.gudang.id : null" @selected="barangSelected" @cancel="selectBarang = false"></barang-selector>
        </b-modal>

        <b-modal v-model="scanBarang" size="md" :hide-header="true" :hide-footer="true">
            <scan-qr-code :selected="barangs" @decoded="scanned"></scan-qr-code>
		</b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import BarangSelector from '../../components/BarangSelector';
import ScanQrCode from '../../components/ScanQrCode';
import Viewer from './Viewer';

export default {
    name: "blending-form",

    props: {
        isEdit: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        Multiselect,
        DatePicker,
        BarangSelector,
        ScanQrCode,
        Viewer,
    },

    data() {
        return {
            form: null,
            barangs: null,
            selectBarang: false,
            scanBarang: false,
            barangIndex: 0,
            gudangOptions: [],
            barangOptions: [],
            isKonfirmasi: false,
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        if (this.value) {
            this.initForm();
        }
    },

    computed: {
    },

    watch: {
        value() {
            this.form = Object.assign({}, this.value);
        }
    },

    methods: {
        resetForm() {
            this.form = Object.assign({}, {
                gudang: null,
                tanggal_blending: null,
            });

            this.barangs = Object.assign([], [
                {
                    bobot: null,
                    grade: null,
                },
            ]);
        },

        initForm() {
            let self = this;

            self.form = Object.assign({}, self.value);
            self.form.tanggal_blending = new Date(self.formatDate(self.form.tanggal_blending, 'YYYY-MM-DD'));
            self.barangs = [];
            self.form.kemasans.forEach(kemasan => {
                self.barangs.push(Object.assign({}, {
                    id: kemasan.pembelian_tembakau.id,
                    code: kemasan.pembelian_tembakau.code,
                    latest_bobot: kemasan.bobot,
                    latest_grade: kemasan.grade ? Object.assign({}, kemasan.grade) : null,
                }));
            });
        },

        kirim(isSave = false) {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    if (isSave) {
                        self.save();
                    } else {
                        self.form.barangs = Object.assign([], self.barangs);
                        self.isKonfirmasi = true;
                    }
                }
            });
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        save() {
            let self = this;

            self.isLoading = true;
            let data = {
                gudang_id: self.form.gudang ? self.form.gudang.id : null,
                tanggal_blending: self.convertUserTimezone(self.form.tanggal_blending),
                pembelian_tembakau_ids: self.barangs.map(barang => barang.id),
                pembelian_tembakau_bobots: self.barangs.map(barang => barang.latest_bobot),
            }

            let api = self.isEdit ? '/api/blendings/'+self.form.id : '/api/blendings';

            self.$Progress.start();
            axios({
                method: self.isEdit ? 'put' : 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        addBarang() {
            this.barangs.push(Object.assign({}, {
                id: null,
                code: null,
                bobot: null,
                grade: null,
            }));
        },

        deleteBarang(index) {
            this.barangs.splice(index, 1);
        },

        findBarang(index) {
            this.barangIndex = index;
            this.selectBarang = true;
        },

        findScan(index) {
            this.barangIndex = index;
            this.scanBarang = true;
        },

        barangSelected(barang) {
            let self = this;

            let index = self.barangOptions.findIndex(b => b.code == barang.code);
            if (index > -1) {
                self.barangs[self.barangIndex] = Object.assign({}, self.barangOptions[index]);
            } else {
                self.barangs[self.barangIndex] = Object.assign({}, barang);
                self.barangOptions.push(barang);
            }
            self.form.gudang = Object.assign({}, barang.latest_gudang);
            self.selectBarang = false;
        },

        scanned(value) {
            let self = this;
            let index = self.barangOptions.findIndex(barang => barang.code == value);
            if (index > -1) {
                self.barangs[self.barangIndex] = Object.assign({}, self.barangOptions[index]);
            } else {
                self.getBarang(value);
            }
            self.scanBarang = false;
        },

        getBarang(code) {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            axios({
                method: 'get',
                url: '/api/pembelian-tembakaus?is_pilih=1&search='+code+'&latest_gudang_id='+(self.form.gudang ? self.form.gudang.id : ''),
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                if (response.data.data.length) {
                    let data = Object.assign({}, response.data.data[0]);
                    self.barangOptions.push(data);
                    self.barangs[self.barangIndex] = Object.assign({}, data);
                    self.form.gudang = Object.assign({}, data.latest_gudang);
                } else {
                    Toast.fire({
                        icon: 'warning',
                        title: 'Kode ' + code + ' tidak ditemukan.'
                    });
                }
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
<style>
.multiselect__placeholder {
    margin-bottom: 0;
}

.disabled-multiselect {
    pointer-events: none;
}

.disabled-multiselect > .multiselect__tags {
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
}

.fit-column {
    width: 0.1%;
    white-space: nowrap;
}
</style>
